import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from './utils';

const BASE_PATHNAME = 'competitors';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getByIds = makeGetByIds({ dataSource, url: `${BASE_PATHNAME}/getmany` });

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();

  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  return {
    getList: getDefaultListHandler({ url: BASE_PATHNAME, dataSource }),

    getByIds,

    getById,

    update,

    getEmptyList: getDefaultEmptyList,
  };
};
